const Col = {
  isComponent: el => el.tagName === 'DIV' && el.classList.contains('col'),
  model: {
    defaults: Object.assign({}, {
      name: 'Column',
      tagName: 'div',
      draggable: true,
      droppable: true,
      copyable: true,
      attributes: {
        id: 'col',
        class: ['col'],
        'attr-xs': 'auto',
        'attr-sm': 'auto',
        'attr-md': 'auto',
        'attr-lg': 'auto',
        // 'attr-order-xs': 'auto',
        // 'attr-order-sm': 'auto',
        // 'attr-order-md': 'auto',
        // 'attr-order-lg': 'auto',
        'attr-align': 'default'
      },
      traits: [
        {
          name: 'id',
          label: 'ID',
          placeholder: 'ID',
          type: 'text'
        },
        {
          name: 'attr-xs',
          label: 'Cols',
          placeholder: 'Cols',
          type: 'select',
          options: ['auto', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
        },
        {
          name: 'attr-sm',
          label: 'Cols sm',
          placeholder: 'Cols sm',
          type: 'select',
          options: ['auto', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
        },
        {
          name: 'attr-md',
          label: 'Cols md',
          placeholder: 'Cols md',
          type: 'select',
          options: ['auto', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
        },
        {
          name: 'attr-lg',
          label: 'Cols lg',
          placeholder: 'Cols lg',
          type: 'select',
          options: ['auto', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
        },
        // {
        //   name: 'attr-order-xs',
        //   label: 'Order',
        //   placeholder: 'Order',
        //   type: 'select',
        //   options: ['auto', 'first', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'last']
        // },
        // {
        //   name: 'attr-order-sm',
        //   label: 'Order sm',
        //   placeholder: 'Order sm',
        //   type: 'select',
        //   options: ['auto', 'first', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'last']
        // },
        // {
        //   name: 'attr-order-md',
        //   label: 'Order md',
        //   placeholder: 'Order md',
        //   type: 'select',
        //   options: ['auto', 'first', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'last']
        // },
        // {
        //   name: 'attr-order-lg',
        //   label: 'Order lg',
        //   placeholder: 'Order lg',
        //   type: 'select',
        //   options: ['auto', 'first', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'last']
        // },
        {
          name: 'attr-align',
          label: 'Align',
          placeholder: 'Align',
          type: 'select',
          options: [
            'default',
            'start',
            'center',
            'end',
            'baseline',
            'stretch'
          ]
        }
      ]
    }),
    init() {
      // this.handleXSChange()
      // this.handleSMChange()
      // this.handleMDChange()
      // this.handleLGChange()
      // this.handleAlignChange()
      this.on('change:attributes:attr-xs', this.handleXSChange)
      this.on('change:attributes:attr-sm', this.handleSMChange)
      this.on('change:attributes:attr-md', this.handleMDChange)
      this.on('change:attributes:attr-lg', this.handleLGChange)
      // this.on('change:attributes:attr-order-xs', this.handleOrderXSChange)
      // this.on('change:attributes:attr-order-sm', this.handleOrderSMChange)
      // this.on('change:attributes:attr-order-md', this.handleOrderMDChange)
      // this.on('change:attributes:attr-order-lg', this.handleOrderLGChange)
      this.on('change:attributes:attr-align', this.handleAlignChange)
    },
    handleXSChange() {
      const targetAttr = this.getAttributes()[`attr-xs`]
      const targetClasses = this.getClasses()
      const removeClasses = targetClasses.filter(e => /col-(\d+)/g.test(e))
      if (removeClasses.length) {
        this.removeClass(removeClasses)
      }
      if (targetAttr !== 'auto') {
        this.addClass(`col-${targetAttr}`)
      }
    },
    handleSMChange() {
      const targetAttr = this.getAttributes()[`attr-sm`]
      const targetClasses = this.getClasses()
      const removeClasses = targetClasses.filter(e => /col-sm-(\d+)/g.test(e))
      if (removeClasses.length) {
        this.removeClass(removeClasses)
      }
      if (targetAttr !== 'auto') {
        this.addClass(`col-sm-${targetAttr}`)
      }
    },
    handleMDChange() {
      const targetAttr = this.getAttributes()[`attr-md`]
      const targetClasses = this.getClasses()
      const removeClasses = targetClasses.filter(e => /col-md-(\d+)/g.test(e))
      if (removeClasses.length) {
        this.removeClass(removeClasses)
      }
      if (targetAttr !== 'auto') {
        this.addClass(`col-md-${targetAttr}`)
      }
    },
    handleLGChange() {
      const targetAttr = this.getAttributes()[`attr-lg`]
      const targetClasses = this.getClasses()
      const removeClasses = targetClasses.filter(e => /col-lg-(\d+)/g.test(e))
      if (removeClasses.length) {
        this.removeClass(removeClasses)
      }
      if (targetAttr !== 'auto') {
        this.addClass(`col-lg-${targetAttr}`)
      }
    },
    // handleOrderXSChange() {
    //   const targetAttr = this.getAttributes()[`attr-order-xs`]
    //   const targetClasses = this.getClasses()
    //   const removeClasses = targetClasses.filter(e => /order-((\d+)|last|first)/g.test(e))
    //   console.log(removeClasses)
    //   if (removeClasses.length) {
    //     this.removeClass(removeClasses)
    //   }
    //   if (targetAttr !== 'auto') {
    //     this.addClass(`order-${targetAttr}`)
    //   }
    // },
    // handleOrderSMChange() {
    //   const targetAttr = this.getAttributes()[`attr-order-sm`]
    //   const targetClasses = this.getClasses()
    //   const removeClasses = targetClasses.filter(e => /order-sm-((\d+)|last|first)/g.test(e))
    //   if (removeClasses.length) {
    //     this.removeClass(removeClasses)
    //   }
    //   if (targetAttr !== 'auto') {
    //     this.addClass(`order-sm-${targetAttr}`)
    //   }
    // },
    // handleOrderMDChange() {
    //   const targetAttr = this.getAttributes()[`attr-order-md`]
    //   const targetClasses = this.getClasses()
    //   const removeClasses = targetClasses.filter(e => /order-md-((\d+)|last|first)/g.test(e))
    //   if (removeClasses.length) {
    //     this.removeClass(removeClasses)
    //   }
    //   if (targetAttr !== 'auto') {
    //     this.addClass(`order-md-${targetAttr}`)
    //   }
    // },
    // handleOrderLGChange() {
    //   const targetAttr = this.getAttributes()[`attr-order-lg`]
    //   const targetClasses = this.getClasses()
    //   const removeClasses = targetClasses.filter(e => /order-lg-((\d+)|last|first)/g.test(e))
    //   if (removeClasses.length) {
    //     this.removeClass(removeClasses)
    //   }
    //   if (targetAttr !== 'auto') {
    //     this.addClass(`order-lg-${targetAttr}`)
    //   }
    // },
    handleAlignChange() {
      const targetAttr = this.getAttributes()['attr-align']
      const targetClasses = this.getClasses()
      const removeClasses = targetClasses.filter(e => /align-self-(start|center|end|baseline|stretch)/g.test(e))
      if (removeClasses.length) {
        this.removeClass(removeClasses)
      }
      if (targetAttr !== 'default') {
        this.addClass(`align-self-${targetAttr}`)
      }
    }
  }
}

export default Col
